import MyModal from 'components/MyModal';
import { Form, Formik } from 'formik';
import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useWebHookScreen } from 'v2/components/Pages/Webhook/context';
import webhookService from 'v2/services/webhook';

import type { IFieldsWebHook } from 'v2/interfaces/webhook/webhook';

import Fields from './Fields';
import { createWebhookSchema } from './validations';

import type { FormikProps } from 'formik';

interface IProps {
  open: boolean;
  close: () => void;
}

const ModalCreate = memo(({ open, close }: IProps) => {
  const { updateList } = useWebHookScreen();

  const onSubmit = useCallback(
    (values: IFieldsWebHook, { setSubmitting }: FormikProps<IFieldsWebHook>) => {
      setSubmitting(true);

      webhookService
        .createURL(values.name, values.product, values.url, values.type)
        .pipe()
        .subscribe(() => {
          toast.success('Webhook criado com sucesso');
          if (updateList) updateList();
          close();
        }, toast.error);
    },
    [close, updateList]
  );

  const onReset = useCallback(() => {
    close();
  }, [close]);

  const initialValues: IFieldsWebHook = {
    name: '',
    product: -1,
    url: '',
    type: 'invoice',
  };

  if (!open) {
    return null;
  }

  return (
    <MyModal
      title='Criar Webhook'
      subTitle={<>Receba dados de suas vendas em qualquer plataforma que suporte notificações pelo método POST.</>}
      hasActive
      closeModal={() => close()}
    >
      <Formik validateOnBlur initialValues={initialValues} validationSchema={createWebhookSchema} onSubmit={onSubmit} onReset={onReset}>
        {() => (
          <Form>
            <Fields />
          </Form>
        )}
      </Formik>
    </MyModal>
  );
});

export default ModalCreate;
